<template>
  <div class="brand">
    <div class="brand__top">
      <div class="logo-block">
        <svg class="mpr-logo" xmlns="http://www.w3.org/2000/svg" width="40" height="14" viewBox="0 0 40 14">
          <path
              d="M34.028 0c3.047 0 4.01 1.68 4.01 3.573 0 1.312-.735 2.78-2.433 3.36l2.188 4.441c.788 1.602 1.209 1.968 2.207 2.124v.463c-.263.019-.526.039-.805.039-2.33 0-3.293-.888-4.274-3.186l-.683-1.603c-.735-1.72-.98-1.854-2.153-1.874v4.268c0 1.081.314 1.545 1.453 1.564v.579c-1.308-.036-1.913-.054-2.444-.057h-.113c-.56 0-1.156.018-2.557.057v-.579c1.138-.019 1.453-.483 1.453-1.564V2.143c0-1.08-.315-1.545-1.453-1.564V0c.823.019 1.524.058 2.172.058C31.733.058 32.89 0 34.028 0zM15.761 0v.58c-.858 0-1.278.308-1.278 1.505 0 .773.017 2.028.035 2.993l.105 6.393c.018 1.389.368 1.64 1.454 1.698v.579c-.858-.019-1.874-.057-2.54-.057-.665 0-1.68.038-2.557.057v-.579c1.208-.095 1.471-.27 1.471-1.873 0-.675-.017-1.448-.035-2.2l-.105-7.359h-.035L7.531 13.884h-.509L2.434 2.433h-.035v9.287c0 .966.297 1.41 1.436 1.45v.578c-.63-.019-1.243-.057-1.926-.057-.683 0-1.296.038-1.909.057v-.579c1.348-.154 1.47-.58 1.506-2.027L1.68 3.92c.017-.599.052-1.236.052-1.815C1.733.869 1.541.675.385.579V0C.98.019 1.84.058 2.26.058c.42 0 .946-.02 1.646-.058L8.02 10.581 12.276 0c.596.039 1.208.058 1.734.058.473 0 1.05-.02 1.751-.058zm7.005 0c3.434 0 4.642 1.68 4.642 3.9 0 2.24-1.33 3.592-4.553 3.592-.509 0-1.122-.019-1.401-.058v4.17c0 1.082.315 1.546 1.453 1.565v.579c-1.308-.036-1.913-.054-2.444-.057h-.113c-.56 0-1.155.018-2.556.057v-.579c1.138-.019 1.452-.483 1.452-1.564V2.143c0-1.08-.314-1.545-1.452-1.564V0c.595.039 1.452.058 2.189.058.928 0 1.856-.058 2.783-.058zm-.56.58c-.314 0-.507.018-.752.076v5.967c.332.078.805.135 1.155.135 1.577 0 2.522-.791 2.522-2.665 0-1.429-.648-3.514-2.924-3.514l-.001.001zm10.63 0c-.314 0-.507.018-.751.076v5.967c.332.078.805.135 1.155.135 1.576 0 2.521-.791 2.521-2.665 0-1.41-.647-3.514-2.924-3.514l-.001.001z"/>
        </svg>
      </div>
      <div class="logo-pj">
        <svg xmlns="http://www.w3.org/2000/svg" width="149" height="28" viewBox="0 0 149 28">
          <g fill="none" fill-rule="evenodd">
            <path d="M0 0L149 0 149 28 0 28z"/>
            <g transform="translate(135 7)">
              <circle cx="12" cy="12" r="1.5" stroke="#000"/>
              <circle cx="4" cy="4" r="3.5" stroke="#000"/>
              <path stroke="#000" d="M10.406 12H9.159c-1.105 0-2-.895-2-2 0-.64.306-1.24.822-1.617l1.053-.766c.893-.65 1.09-1.902.44-2.794C9.096 4.306 8.495 4 7.856 4H7.5h0"/>
              <circle cx="4" cy="3.5" r="1" stroke="#000"/>
              <path fill="#000" fill-rule="nonzero" d="M4 4.5c1.156 0 2.159.653 2.66 1.611l-.737.837C5.683 6.112 4.913 5.5 4 5.5c-.869 0-1.608.554-1.884 1.327l-.755-.755C1.869 5.136 2.86 4.5 4 4.5z"/>
            </g>
            <path fill="#000" fill-rule="nonzero"
                  d="M9.14 19v-4.395h2.835c1.935 0 3.3-1.245 3.3-3.15 0-1.905-1.365-3.135-3.3-3.135H8V19h1.14zm2.745-5.415H9.14V9.34h2.745c1.335 0 2.25.705 2.25 2.115 0 1.41-.915 2.13-2.25 2.13zM15.85 19l.855-2.415h4.665L22.225 19h1.215L19.525 8.32h-.96L14.635 19h1.215zm5.19-3.405h-3.99l2.01-5.64 1.98 5.64zM26.7 19V9.34h3.09V8.32h-7.32v1.02h3.09V19h1.14zm5.525 0V8.32h-1.14V19h1.14zm9.02 0v-1.02h-5.49v-3.855h4.68v-1.02h-4.68V9.34h5.49V8.32h-6.63V19h6.63zm2.81 0v-8.565L49.725 19h1.08V8.32h-1.14v8.535l-5.67-8.535h-1.08V19h1.14zm12.275 0V9.34h3.09V8.32H52.1v1.02h3.09V19h1.14zm8.665.09c1.95 0 3.33-1.275 3.33-3.33V8.32h-1.14v7.29c0 1.575-.795 2.46-2.19 2.46-.885 0-1.29-.315-1.68-.705l-.765.765c.66.66 1.425.96 2.445.96zm8.9 0c1.11 0 1.995-.39 2.655-1.05 1.005-1.005 1.08-1.935 1.08-4.38s-.075-3.375-1.08-4.38c-.66-.66-1.545-1.05-2.655-1.05-1.11 0-2.01.39-2.67 1.05-.965.965-1.059 1.86-1.065 4.094v.286c0 2.445.06 3.375 1.065 4.38.66.66 1.56 1.05 2.67 1.05zm0-1.02c-.72 0-1.35-.255-1.845-.75-.647-.661-.743-1.405-.75-3.393v-.267c0-2.19.075-2.97.75-3.66.495-.495 1.125-.75 1.845-.75s1.35.255 1.845.75c.675.69.75 1.47.75 3.66 0 2.19-.075 2.97-.75 3.66-.495.495-1.125.75-1.845.75zm9.29 1.02c2.16 0 3.735-1.485 3.735-3.615V8.32h-1.14v7.065c0 1.62-1.035 2.685-2.595 2.685-1.56 0-2.58-1.065-2.58-2.685V8.32h-1.14v7.155c0 2.13 1.56 3.615 3.72 3.615zM90.3 19v-4.74h2.565l2.43 4.74h1.335l-2.535-4.845c1.38-.285 2.325-1.305 2.325-2.865 0-1.845-1.305-2.97-3.165-2.97H89.16V19h1.14zm2.85-5.745H90.3V9.34h2.85c1.245 0 2.13.66 2.13 1.965 0 1.305-.885 1.95-2.13 1.95zM99.44 19v-8.565L105.11 19h1.08V8.32h-1.14v8.535L99.38 8.32H98.3V19h1.14zm15.77 0v-1.02h-5.49v-3.855h4.68v-1.02h-4.68V9.34h5.49V8.32h-6.63V19h6.63zm4.855 0v-4.41l3.15-6.27h-1.23l-2.49 5.115-2.52-5.115h-1.23l3.18 6.27V19h1.14zm6.325.08c2.235 0 3.69-1.155 3.69-3.03 0-.885-.33-1.605-.9-2.1-.48-.435-.945-.615-1.935-.765L126 12.99c-.555-.09-1.065-.27-1.395-.555-.33-.285-.48-.72-.48-1.245 0-1.2.825-1.995 2.265-1.995 1.11 0 1.845.315 2.49.93l.735-.735c-.915-.81-1.815-1.17-3.18-1.17-2.115 0-3.42 1.185-3.42 3 0 .87.285 1.53.825 2.01.48.42 1.11.675 1.95.81l1.245.18c.765.12 1.065.225 1.395.525.36.315.525.765.525 1.335 0 1.26-.96 1.98-2.535 1.98-1.2 0-2.025-.27-2.91-1.155l-.765.765c.99 1.005 2.055 1.41 3.645 1.41z"/>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BrandTop',
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState([
      'userAgent', 'urls'
    ])
  },
  methods: {},
  watch: {},
  beforeCreate: function () {
  },
  beforeMount: function () {
  },
  mounted: function () {
  },
  beforeUpdate: function () {
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  created: function () {
  },
  destroyed: function () {
  }
};
</script>

<style lang="scss">
.brand {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 50px;
  z-index: 99999;
  pointer-events: none;
  background-color: #ffffff;

  @include media("<tablet") {
    height: 38px;
    border-bottom: 1px solid #d3d3d3;
  }

  @include media("<=tablet", "landscape") {
    height: 38px;
    border-bottom: 1px solid #d3d3d3;
  }

  & > * {
    pointer-events: all;
  }

  .brand__top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100vw - 100px);
    margin: 0 auto;
    box-sizing: border-box;
    border-bottom: 1px solid #d3d3d3;

    @include media("<tablet") {
      width: calc(100vw - 50px);
      padding: 0;
      height: 38px;
      text-align: left;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d3d3d3;
    }
    @include media("<=tablet", "landscape") {
      width: calc(100vw - 50px);
      padding: 0;
      height: 38px;
      text-align: left;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #d3d3d3;
    }
    @include media("<phone") {
      padding: 0 20px;
      width: 100vw;
    }
  }

  .logo-block {
    display: flex;
    align-items: center;
    @include media("<phone") {
      width: 182px;
    }
  }

  .logo-pj {
    width: 149px;
    height: 28px;
  }

  .mpr-logo {
    width: 40px;
    height: 14px;
  }
}
</style>
